export default [
  {
    path: '/whitelist-ip',
    name: 'whitelist-ip',
    component: () => import('@/views/whitelistIP/index.vue'),
    meta: {
      pageTitle: 'breadcrumb.whitelistIP',
      navActiveLink: 'whitelist-ip',
      resource: 'manage-whitelist-ips',
      action: 'manage',
      breadcrumb: [
        {
          text: 'breadcrumb.whitelistIP',
          active: true,
        },
      ],
    },
  },
]
